import { useQuery } from '@tanstack/react-query';
import { getOrderSettings } from '../orders.api';

/** FR16 default staleness threshold — read-only until h3-6 ships the settings editor. */
export function useOrderSettings() {
  return useQuery({
    queryKey: ['orders', 'settings'],
    queryFn: getOrderSettings,
    staleTime: 60 * 1000,
  });
}
